var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDeprecated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 8.21363H11.7857V2.85649C11.7857 2.19913 11.2526 1.66602 10.5952 1.66602H9.40472C8.74735 1.66602 8.21425 2.19913 8.21425 2.85649V8.21363H2.8571C2.19974 8.21363 1.66663 8.74674 1.66663 9.40411V10.5946C1.66663 11.252 2.19974 11.7851 2.8571 11.7851H8.21425V17.1422C8.21425 17.7996 8.74735 18.3327 9.40472 18.3327H10.5952C11.2526 18.3327 11.7857 17.7996 11.7857 17.1422V11.7851H17.1428C17.8002 11.7851 18.3333 11.252 18.3333 10.5946V9.40411C18.3333 8.74674 17.8002 8.21363 17.1428 8.21363Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDeprecated);
export default __webpack_public_path__ + "static/media/add_deprecated.f575e22f3a5351e7c2d56f3a5377ae3d.svg";
export { ForwardRef as ReactComponent };